import React from 'react';
import styled from '@emotion/styled';
import type { Nullable } from 'corgi-types';
import { flexDirection } from 'styled-system';

import { flexGap } from 'common/theme/system-utilities';
import type { ArticleLabelsList } from '../../../types/labels';
import type { DiscountLabelCampaign } from '../../DiscountLabels';
import DiscountLabels from '../../DiscountLabels';

const LABEL_POSITION = ['sp_4', null, null, 'sp_8'];

interface ProductCardImageLabelsProps {
  labels_v2: ArticleLabelsList;
  sponsored?: Nullable<{ owner?: string | null }>;
  campaigns?: DiscountLabelCampaign[];
  brand?: string;
  isSmallVariant?: boolean;
}

const StyledDiscountLabels = styled(DiscountLabels)`
  ${flexDirection};
  ${flexGap};
`;

export const ProductCardImageLabels = ({
  labels_v2,
  sponsored,
  campaigns,
  brand,
  isSmallVariant,
}: ProductCardImageLabelsProps) => (
  <StyledDiscountLabels
    labels_v2={labels_v2}
    sponsored={sponsored}
    campaigns={campaigns}
    themeBottom={LABEL_POSITION}
    themeLeft={LABEL_POSITION}
    brand={brand}
    isPLP
    sortLongestBelow
    flexDirection="row"
    gap="sp_4"
    isSmallVariant={isSmallVariant}
  />
);
